import React, { useState } from "react";
import { toastr } from "react-redux-toastr";
import { Controller, useForm } from "react-hook-form";
import { DropdownList } from "react-widgets";
import ErrorMessage from "../../../components/text/ErrorMessage";
import {
  Customer,
  Phone,
  EmailAddress,
  District,
  AgeLimit,
  Influencer,
  Designation,
  Divisions,
} from "../../../core/api/models";
import CustomerPhone from "../../../components/customer-phone";
import CustomerEmail from "../../../components/customer-email";
import DateInput from "../../../components/form-group/date-input";
import { UploadUserImage } from "../../../components/upload";
import Countries from "../../../utils/countries.json";
import States from "../../../utils/states.json";
import title from "../../../utils/title.json";
import "react-widgets/dist/css/react-widgets.css";
import api from "../../../api";
import {
  CheckPhoneNumberEmpty,
  ValidateEmail,
  ValidatePhoneNumberRegEx,
  ValidateString,
} from "../../../utils/Validatation";
import moment from "moment";
import { useDataLoader } from "react-remote-data-hooks";
import validator from "validator";

const AddressType = [
  { name: "Home", value: "home" },
  { name: "Work", value: "work" },
];

const NewCustomerCreate: React.FunctionComponent<{
  error?: string;
  onCreateCustomer: (data: Customer) => void;
  setStage?: (stage: string) => void;
  customerDetails?: Customer;
  phones?: Phone[];
  emails?: EmailAddress[];
  civilId?: string;
  companyId?: string;
  onCancel?: () => void;
}> = (props) => {
  const [isAddressSelected, setAddressSelected] = useState<boolean>(false);
  const [isAddressPrimary, setAddressPrimary] = useState<boolean>(false);

  const [isEmailEnable, setIsEmailEnable] = useState<boolean>(true);

  const [isSubmiting, setIsSubmiting] = useState<boolean>(false);

  const [customerDetails, setCustomerDetails] = useState<Customer | undefined>(
    props.customerDetails
  );

  const [selectedPhone, setSelectedPhone] = useState<Phone[] | undefined>(
    props.customerDetails?.phones
  );
  const [selectedEmail, setSelectedEmail] = useState<
    EmailAddress[] | undefined
  >(props.customerDetails?.emails);

  const { data: influencers } = useDataLoader<Influencer[]>(() =>
    api.influencer.loadAllInfluencer()
  );

  const { data: designations } = useDataLoader<Designation[]>(() =>
    api.designation.loadAllDesignation()
  );

  const { data: divisions } = useDataLoader<Divisions[]>(() =>
    api.divisionsUnderCompany.loadAllDivisions()
  );

  const {
    control,
    handleSubmit,
    errors,
    clearErrors,
    watch,
    setValue,
  } = useForm<Customer>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  React.useEffect(() => {
    if (watch("dob")) {
      const year = moment().diff(watch("dob"), "years", true);
      const ageRange = AgeLimit?.find((a) => a.from <= year && a.to >= year);
      setValue("ageRange", ageRange?.name);
    }
  }, [watch("dob")]);
  const [districtList, setDistrictList] = useState([]);

  const statesList =
    watch("country") === "India" || !watch("country") ? States : [];

  const setAsPrimary = () => {
    setAddressPrimary(!isAddressPrimary);
  };

  const onSubmit = async (data?: any) => {
    setIsSubmiting(true);
    const updateData: Customer = {
      prefix: data?.prefix,
      firstName: data?.firstName,
      lastName: data?.lastName,
      ageRange: data?.ageRange,
      dob: data?.dob,
      phones: selectedPhone?.filter((x) => CheckPhoneNumberEmpty(x.phone)),
      emails: selectedEmail?.filter((x) => ValidateEmail(x.email)),
      photo: data.photo,
      avatar: data.avatar,
      civilId: data.civilId,
      // companyId: props.companyId,
      influencerId: data.influencerId,
      designationId: data.designationId,
      divisionId: data.divisionId,
    };
    if (isAddressSelected && checkAddrsssIsValid(data)) {
      updateData.addresses = [
        {
          houseName: data?.houseName,
          houseNumber: data?.houseNumber,
          country: data?.country,
          state: data?.state,
          district: data?.district,
          city: data?.city,
          address: data?.address,
          postalCode: data?.postalCode,
          isPrimary: false,
        },
      ];
    }
    try {
      const response = props.customerDetails?._id
        ? await api.customer.updateCustomer(
          updateData,
          props.customerDetails?._id
        )
        : await api.company.createCustomer(updateData);
      props.onCreateCustomer(response);
      toastr.success("Success", "Customer added successfully");
      props.setStage?.("lead-details" || "");
    } catch (error) {
      if (error?.response?.data?.data?.message) {
        toastr.error("Error", error?.response?.data?.data?.message);
      } else {
        toastr.error("Error", error?.response?.data?.message);
      }
    }
    setIsSubmiting(false);
  };

  const checkAddrsssIsValid = (data?: Customer) => {
    return (
      data?.country ||
      data?.state ||
      data?.district ||
      data?.city ||
      data?.address ||
      data?.street ||
      data?.postalCode
    );
  };

  const onChangePhone = (phoneNumber: Phone[]) => {
    setSelectedPhone(phoneNumber);
  };

  const onChangeEmail = (emailAdd: EmailAddress[]) => {
    setSelectedEmail(emailAdd);
  };

  const onCancel = () => {
    props.setStage?.("lead-details" || "");
    props.onCancel?.();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="p-4">
        <div className="form-group d-flex flex-wrap align-items-center">
          <Controller
            control={control}
            name="photo"
            defaultValue={props?.customerDetails?.photo}
            render={({ onChange, value, name }) => (
              <UploadUserImage
                id={"photo"}
                title={"Add Photo"}
                onChange={onChange}
                default={props?.customerDetails?.photo}
              />
            )}
          />
        </div>
        <div className="form-group font-weight-semibold mb-4">
          <label htmlFor="" className="font-sm text-uppercase">
            Title
          </label>
          <Controller
            control={control}
            // rules={{ required: true }}
            name="prefix"
            defaultValue={props?.customerDetails?.prefix}
            render={({ onChange, value, name }) => (
              <DropdownList
                value={value}
                defaultValue={value}
                data={title}
                textField={"name"}
                valueField={"name"}
                placeholder={"Select prefix"}
                onChange={(val) => {
                  onChange(val.name);
                }}
              />
            )}
          />
          {errors.prefix && <ErrorMessage>Prefix is required</ErrorMessage>}
        </div>
        <div className="form-group font-weight-semibold mb-4">
          <label htmlFor="" className="font-sm text-uppercase">
            First Name<span className="text-danger">*</span>
          </label>

          <Controller
            control={control}
            rules={{
              required: true,
              validate: (value) => {
                return ValidateString(value);
              },
              maxLength: 25,
            }}
            name="firstName"
            defaultValue={props?.customerDetails?.firstName}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="First Name"
                name={name}
                value={value}
                onChange={onChange}
                id="firstName"
              />
            )}
          />
          {errors.firstName && errors.firstName.type === "required" && (
            <ErrorMessage>First Name is required</ErrorMessage>
          )}
          {errors.firstName && errors.firstName.type === "validate" && (
            <ErrorMessage>Invalid First Name</ErrorMessage>
          )}
          {errors.firstName && errors.firstName.type === "maxLength" && (
            <ErrorMessage>
              First name should contains maximum 25 characters
            </ErrorMessage>
          )}
        </div>
        <div className="form-group font-weight-semibold mb-4">
          <label htmlFor="" className="font-sm text-uppercase">
            Last Name<span className="text-danger">*</span>
          </label>
          <Controller
            control={control}
            rules={{
              required: true,
              validate: (value) => {
                return ValidateString(value);
              },
              maxLength: 25,
            }}
            name="lastName"
            defaultValue={props?.customerDetails?.lastName}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Last Name"
                name={name}
                value={value}
                onChange={onChange}
                id="lastName"
              />
            )}
          />
          {errors.lastName && errors.lastName.type === "required" && (
            <ErrorMessage>Last Name is required</ErrorMessage>
          )}
          {errors.lastName && errors.lastName.type === "validate" && (
            <ErrorMessage>Invalid Last Name</ErrorMessage>
          )}
          {errors.lastName && errors.lastName.type === "maxLength" && (
            <ErrorMessage>
              Last name should contains maximum 25 characters
            </ErrorMessage>
          )}
        </div>
        <div className="form-group font-weight-semibold mb-4">
          <label htmlFor="" className="font-sm text-uppercase">
            Phone<span className="text-danger">*</span>
          </label>

          <Controller
            control={control}
            rules={{
              required: true,
              validate: (value) => {
                return !(
                  !selectedPhone ||
                  (selectedPhone &&
                    selectedPhone?.filter((x) =>
                      ValidatePhoneNumberRegEx(x.phone, x.phoneType)
                    ).length === 0)
                );
              },
            }}
            name="phones"
            defaultValue={props.customerDetails?.phones}
            render={({ onChange, value, name }) => (
              <CustomerPhone
                className="form-control p-0 rounded-sm font-weight-semibold"
                placeholder="Phone"
                value={selectedPhone}
                onChange={(val) => {
                  onChangePhone(val);
                  onChange(val);
                }}
              />
            )}
          />
          {errors.phones && (
            <div>
              <ErrorMessage>Valid Phone is required</ErrorMessage>
            </div>
          )}
        </div>
        <div className="form-group font-weight-semibold mb-4">
          <label
            htmlFor=""
            className="font-sm text-uppercase d-flex align-items-end"
          >
            Email
            <div className="ml-auto switch switch--sm">
              <input
                type="checkbox"
                name="emails"
                onChange={(val) => {
                  setIsEmailEnable(!isEmailEnable);
                  if (isEmailEnable) {
                    clearErrors("emails");
                  }
                }}
                id="emailSwitch"
                checked={isEmailEnable}
              />
              <label htmlFor="emailSwitch">
                <div className="switch-handle mr-2"></div>
              </label>
            </div>
          </label>
          <Controller
            control={control}
            rules={{
              required:
                (!selectedEmail ||
                  (selectedEmail &&
                    selectedEmail?.filter((x) => ValidateEmail(x.email))
                      .length === 0)) &&
                isEmailEnable,
            }}
            name="emails"
            defaultValue={props.customerDetails?.emails}
            render={({ onChange, value, name }) => (
              <CustomerEmail
                className="form-control p-0 rounded-sm font-weight-semibold"
                placeholder="Email"
                value={selectedEmail}
                onChange={(val) => {
                  onChangeEmail(val);
                  onChange(val);
                }}
                disabled={!isEmailEnable}
              />
            )}
          />
          {errors.emails && (
            <div>
              <ErrorMessage>Email is required</ErrorMessage>
            </div>
          )}
        </div>

        <div className="form-group font-weight-semibold mb-4">
          <label htmlFor="" className="font-sm text-uppercase">
            Influencer
          </label>
          <Controller
            control={control}
            name="influencerId"
            defaultValue={props?.customerDetails?.influencer?._id}
            render={({ onChange, value, name }) => (
              <DropdownList
                value={value}
                defaultValue={value}
                data={influencers?.map((key) => {
                  return {
                    _id: key._id,
                    name: key.name,
                  };
                })}
                textField={"name"}
                valueField={"_id"}
                placeholder={"Select Influencer"}
                onChange={(val) => {
                  onChange(val._id);
                }}
              />
            )}
          />
          {errors.influencerId && (
            <ErrorMessage>Influencer is required</ErrorMessage>
          )}
        </div>

        <div className="form-group font-weight-semibold mb-4">
          <label htmlFor="" className="font-sm text-uppercase">
            Designation<span className="text-danger">*</span>
          </label>
          <Controller
            control={control}
            rules={{ required: true }}
            name="designationId"
            defaultValue={props?.customerDetails?.designation?._id}
            render={({ onChange, value, name }) => (
              <DropdownList
                value={value}
                defaultValue={value}
                filter="contains"
                data={designations?.map((key) => {
                  return {
                    _id: key._id,
                    name: key.name,
                  };
                })}
                textField={"name"}
                valueField={"_id"}
                placeholder={"Select Designation"}
                onChange={(val) => {
                  onChange(val._id);
                }}
              />
            )}
          />
          {errors.designationId && (
            <ErrorMessage>Designation is required</ErrorMessage>
          )}
        </div>

        <div className="mb-4">
          <h5 className="text-uppercase font-weight-semibold mb-2">Address</h5>
          {!isAddressSelected && (
            <button
              type="button"
              className="btn btn-link font-sm p-0 font-weight-semibold"
              onClick={() => setAddressSelected(true)}
            >
              + add address
            </button>
          )}
        </div>
        {isAddressSelected && (
          <div>
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                House Name
              </label>
              <Controller
                control={control}
                // rules={{ required: isAddressSelected }}
                name="houseName"
                defaultValue={props?.customerDetails?.houseName}
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="House Name"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="houseName"
                  />
                )}
              />
              {errors.houseName && (
                <ErrorMessage>
                  {errors.houseName.type === "required"
                    ? "House Name is required"
                    : "Invalid House Name"}
                </ErrorMessage>
              )}
            </div>
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                House Number
              </label>
              <Controller
                control={control}
                // rules={{ required: isAddressSelected }}
                name="houseNumber"
                defaultValue={props?.customerDetails?.houseNumber}
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="House Number"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="houseNumber"
                  />
                )}
              />
              {errors.houseNumber && (
                <ErrorMessage>
                  {errors.houseNumber.type === "required"
                    ? "House Number is required"
                    : "Invalid House Number"}
                </ErrorMessage>
              )}
            </div>
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                Country<span className="text-danger">*</span>
              </label>

              <Controller
                control={control}
                rules={{ required: true }}
                name="country"
                defaultValue="India"
                render={({ onChange, value, name }) => (
                  <DropdownList
                    value={value}
                    defaultValue={value}
                    data={Countries}
                    textField={"name"}
                    valueField={"name"}
                    placeholder={"Select country"}
                    onChange={(val) => {
                      onChange(val.name);
                    }}
                    filter={"contains"}
                  />
                )}
              />
              {errors.country && (
                <ErrorMessage>
                  {errors.country.type === "required"
                    ? "Country is required"
                    : "Invalid Country"}
                </ErrorMessage>
              )}
            </div>

            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                State
              </label>

              <Controller
                control={control}
                name="state"
                render={({ onChange, value, name }) => (
                  <DropdownList
                    value={value}
                    defaultValue={value}
                    data={statesList}
                    textField={"state"}
                    valueField={"state"}
                    placeholder={"Select state"}
                    onChange={(val) => {
                      onChange(val.state);
                      setDistrictList(val.districts);
                    }}
                  />
                )}
              />
              {errors.state && (
                <ErrorMessage>
                  {errors.state.type === "required"
                    ? "State is required"
                    : "Invalid State"}
                </ErrorMessage>
              )}
            </div>

            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                District
              </label>
              <Controller
                control={control}
                name="district"
                render={({ onChange, value, name }) => (
                  <DropdownList
                    value={value}
                    defaultValue={value}
                    data={districtList?.map((d) => {
                      return {
                        name: d,
                      };
                    })}
                    textField={"name"}
                    valueField={"name"}
                    placeholder={"Select district"}
                    onChange={(val) => {
                      onChange(val.name);
                    }}
                  />
                )}
              />
              {errors.district && (
                <ErrorMessage>
                  {errors.district.type === "required"
                    ? "District is required"
                    : "Invalid District"}
                </ErrorMessage>
              )}
            </div>

            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                Building Address<span className="text-danger">*</span>
              </label>

              <Controller
                control={control}
                rules={{ required: true }}
                name="address"
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="Building Address"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="address"
                  />
                )}
              />
              {errors.address && (
                <ErrorMessage>
                  {errors.address.type === "required"
                    ? "Building Address is required"
                    : "Invalid Building Address"}
                </ErrorMessage>
              )}
            </div>
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                City
              </label>

              <Controller
                control={control}
                name="city"
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="City"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="city"
                  />
                )}
              />
              {errors.city && (
                <ErrorMessage>
                  {errors.city.type === "required"
                    ? "City is required"
                    : "Invalid City"}
                </ErrorMessage>
              )}
            </div>
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                Zip code
              </label>
              <Controller
                control={control}
                name="postalCode"
                rules={{
                  required: false,
                  pattern: {
                    value: /^[0-9]{6}$/,
                    message: "Invalid Postal Code",
                  },
                }}
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="Postal Code"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="postalCode"
                  />
                )}
              />
              {errors.postalCode && (
                <ErrorMessage>
                  {errors.postalCode.type === "required"
                    ? "Postal Code is required"
                    : "Invalid Postal Code"}
                </ErrorMessage>
              )}
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-auto ">
            <button
              onClick={() => onCancel()}
              type="button"
              className="btn btn-outline-dark btn-block font-normal font-weight-bold"
            >
              Cancel
            </button>
          </div>
          <div className="col-auto ">
            <button
              disabled={isSubmiting}
              className="btn btn-primary btn-block font-normal font-weight-bold"
            >
              Add Contact
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default NewCustomerCreate;
